<template>
  <div
    :id="request.id"
    :class="cardColor"
    @addIsDirty="isDirty = true"
    @removeIsDirty="isDirty = false"
  >
    <b-row :style="cardStyle" align-v="center" class="m-0 mt-1">
      <b-col class="text-md-right text-sm-right text-center" cols="12" lg="1" md="1" sm="1" xl="1">
        <b-button :v-b-toggle="request.id + 'collapsed'" variant="link" @click="visible = !visible">
          <b-img :src="visible ? arrowUpCircle : arrowDownCircle"></b-img>
        </b-button>
      </b-col>

      <b-col class="mt-3 pl-4 text-center" cols="12" lg="3" md="7" sm="7" xl="3">
        <p class="name-style">{{ request.name }}</p>
      </b-col>
      <b-col class="text-center px-0" cols="12" lg="2" md="4" sm="4" xl="2">
        <new-status-map
          v-if="showStatus"
          :status="request['matchedApplication'][0]['statusMap']"
          :pendingReason="request['matchedApplication'][0]['pendingReason']"
        />
      </b-col>
      <b-col class="text-center" cols="12" lg="5" md="10" sm="10" xl="5">
        <multiselect
          v-model="selected"
          :allow-empty="isMultiple"
          :clear-on-select="false"
          :close-on-select="!isMultiple"
          :custom-label="customLabel"
          :multiple="isMultiple"
          :options="request['systemRoles']"
          :show-labels="false"
          class="my-2"
          deselect-label="Can't remove this value"
          label="name"
          open-direction="top"
          placeholder="Please select a role"
          track-by="id"
          @input="roleSelection()"
        >
          <template slot="singleLabel" slot-scope="props">
            <div class="option__desc">
              <div>
                <b-icon
                  v-if="props.option.id.includes('remove')"
                  class="text-danger"
                  icon="trash-fill"
                ></b-icon>
                <strong> {{ props.option.name }}</strong>
              </div>
              <div>{{ props.option.description }}</div>
            </div>
          </template>

          <template slot="option" slot-scope="props">
            <div class="option__desc">
              <div>
                <b-icon
                  v-if="props.option.id.includes('remove')"
                  class="text-danger"
                  icon="trash-fill"
                >
                </b-icon>
                <strong> {{ props.option.name }}</strong>
              </div>
              <div>{{ props.option.description }}</div>
            </div>
          </template>
        </multiselect>
        <div v-if="request['matchedApplication'].length > 0">
          <strong>Request Type: </strong>{{ request['matchedApplication'][0]['requestType'] }}
          <span
            v-if="
              request['matchedApplication'][0]['requestType'] === 'Delete Request' ||
                request['matchedApplication'][0]['requestType'] === 'Deactivate Request'
            "
          >
            ({{ request['matchedApplication'][0]['deleteReason'] }})
          </span>
        </div>
      </b-col>
      <b-col class="text-center" cols="12" lg="1" md="1" sm="1" xl="1">
        <b-button v-if="canDeleteRequest" v-b-modal="'delete-modal_' + request.id" variant="link">
          <b-icon
            :style="{ color: '#ff0000' }"
            class="rounded-circle bg-light p-2"
            font-scale="2.7"
            icon="trash-fill"
          ></b-icon>
        </b-button>
      </b-col>
    </b-row>
    <b-collapse :id="request.id + 'collapsed'" v-model="visible" class="mt-2">
      <b-card class="px-4">
        <strong>Application Description</strong>
        <p class="description-style">{{ request.description }}</p>
      </b-card>
    </b-collapse>
    <b-modal
      :id="'delete-modal_' + request.id"
      centered
      header-bg-variant="danger"
      header-text-variant="light"
      size="sm"
      title="Please choose a reason for removing access"
      @ok="onDeleteModalOk"
    >
      <b-container fluid>
        <b-form-radio-group v-model="selectedDeleted" :options="deleteOptions"></b-form-radio-group>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import NewStatusMap from '../common/NewStatusMap';
  import arrowUpCircle from '../../../images/arrowUpCircle.png';
  import arrowDownCircle from '../../../images/arrowDownCircle.png';

  export default {
    props: ['request', 'isMultiple', 'isRecommended'],
    components: {
      Multiselect,
      NewStatusMap,
    },
    data() {
      return {
        isDirty: false,
        visible: false,
        arrowUpCircle: arrowUpCircle,
        arrowDownCircle: arrowDownCircle,
        selected: null,
        defaultSelection: null,
        cardStyle: 'min-height: 100px;',
        systemRole: {},
        bgColor: '',
        accessStatus: '',
        style: {
          Active: { color: '#229406' },
          Inactive: { color: '#ff0000' },
          null: { color: '#000000' },
        },
        icon: {
          Active: 'check-lg',
          Inactive: 'x-lg',
          null: '',
        },
        selectedDeleted: null,
        deleteOptions: [
          {
            text: 'No longer employed at site',
            value: 'remove_access_1',
            name: 'Remove Access',
            type: 'Delete Request',
          },
          {
            text: 'No longer assigned to study',
            value: 'remove_access_2',
            name: 'Remove Access',
            type: 'Delete Request',
          },
          {
            text: 'No longer needed',
            value: 'remove_access_3',
            name: 'Remove Access',
            type: 'Delete Request',
          },
        ],
        checkForStatus: true,
      };
    },
    computed: {
      canDeleteRequest() {
        return (
          this.request['matchedApplication'].length > 0 &&
          this.request['matchedApplication'][0]['requestType'] !== 'Delete Request' &&
          this.request['matchedApplication'][0]['requestType'] !== 'Deactivate Request' &&
          !this.isDirty
        );
      },
      cardColor() {
        return this.isDirty ? 'bg-light' : '';
      },
      showStatus() {
        return this.request['matchedApplication'].length > 0 && !this.isDirty;
      },
    },
    created() {
      if (this.request['matchedApplication'].length > 0) {
        this.checkForStatus = false;
      }
      this.accessStatus =
        this.request.matchedApplication.length > 0
          ? this.request['matchedApplication'][0]['accountStatus']
          : null;
      if (this.canDeleteRequest) {
        let roleRemovalOptions = this.deleteOptions.map(
          ({ text: description, value: id, ...rest }) => ({
            description,
            id,
            ...rest,
          }),
        );
        this.request['systemRoles'] = this.request['systemRoles'].concat(roleRemovalOptions);
      }

      const requestType =
        this.request['matchedApplication'].length > 0
          ? this.request['matchedApplication'][0]['requestType']
          : null;
      const isDeleteRequest =
        requestType === 'Delete Request' || requestType === 'Deactivate Request';
      if (!this.canDeleteRequest && !isDeleteRequest) {
        this.request['systemRoles'].push({
          description: 'No longer needed',
          id: 'remove_access_4',
          name: 'Remove Access',
          type: 'Delete Request',
        });
      }

      if (
        this.request['matchedApplication'].length > 0 &&
        this.request['matchedApplication'][0]['status'] === null
      ) {
        this.request['matchedApplication'][0]['status'] = 'SUBMITTED';
      }
      this.selectDependOnMultiple();
      this.checkForMatchingApps();
    },
    mounted() {
      this.roleSelection();
    },
    methods: {
      onDeleteModalOk() {
        this.selected = this.request['systemRoles'].find(role => role.id === this.selectedDeleted);
        this.roleSelection();
      },
      selectDependOnMultiple() {
        if (this.isMultiple) {
          this.selected = this.request.selectedRoles.length > 0 ? this.request.selectedRoles : [];
        } else {
          this.selected =
            this.request.selectedRoles.length > 0 ? this.request.selectedRoles[0] : null;
        }
      },
      checkForMatchingApps() {
        if (this.request['matchedApplication'].length > 0 && !this.isRecommended) {
          this.selected = this.request.systemRoles.filter(role =>
            this.request['matchedApplication'].some(el => el.systemRoleId === role['id']),
          );
        }
      },
      customLabel({ name, description }) {
        return `${name} \n ${description}`;
      },
      roleSelection() {
        if (this.selected !== null) {
          this.isMultiple ? this.multiSelection() : this.singleSelection();
        }
      },
      status() {
        if (!this.selected || !this.selected.id) {
          return 'nothing';
        }
        if (this.selected.id === 'remove_access_4') {
          return 'Delete Request';
        }
        if (this.request['matchedApplication'].length > 0) {
          if (this.selected?.id.includes('remove_access')) {
            return 'Delete Request';
          } else if (this.selected['id'] !== this.request.matchedApplication[0]['systemRoleId']) {
            return 'Modify Existing Role Access';
          } else {
            return 'nothing';
          }
        } else {
          return 'New Account Access';
        }
      },

      singleSelection() {
        let requestType;
        requestType = this.status();

        this.cardStyle = 'min-height: 100px;';
        let systemRole = [];
        if (this.selected === {} || this.selected.id === 'none') {
          this.selected = null;
        } else {
          systemRole = this.selected;
        }
        let payload = {
          id: this.request.id,
          name: this.request.name,
          systemRole: systemRole,
          type: requestType,
          deleteReason: requestType === 'Delete Request' ? systemRole.description : null,
        };
        this.$emit('addRequest', payload);
      },
      multiSelection() {
        if (
          this.selected.findIndex(element => element.id === 'none') > -1 ||
          this.selected.length === 0
        ) {
          this.selected = [];
        }
        this.cardStyle = 'min-height: 100px;';
        this.$emit('addRequest', {
          id: this.request.id,
          name: this.request.name,
          systemRole: this.selected,
        });
      },
    },
  };
</script>

<style>
  .name-style {
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #00004e;
    margin-bottom: 0px;
  }

  .description-style {
    font-weight: 400;
    line-height: 28px;
    font-size: 14px;
    letter-spacing: 0.25px;
  }

  .multiselect__tag {
    white-space: pre-line;
    line-height: 20px;
  }

  .multiselect__tag::first-line {
    font-weight: bold;
  }
</style>
